import { Action } from 'redux'
import { UserAccountActions } from '../../../reducers/userAccount/actionNames'

const togglePremiumInfoModal = (toggle = false): ITogglePremiumInfoModal => ({
  toggle,
  type: UserAccountActions.ToggleInfoModal,
})

export interface ITogglePremiumInfoModal
  extends Action<UserAccountActions.ToggleInfoModal> {
  toggle?: boolean
}

export default togglePremiumInfoModal
